module.exports = __webpack_public_path__ + "static/media/p8_img5.0cd9faf2.svg";